var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"skip-links"},_vm._l((_vm.links),function(link,index){return _c('a',{key:index,staticClass:"skip-links__link button",attrs:{"href":link.href},on:{"click":_vm.skipTo}},[_vm._v(" "+_vm._s(link.text)+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }